import React, { FC, PropsWithChildren } from 'react';
import classNames from 'classnames';
import View from '../view';

interface IBadgeProps {
  /**
   * css class
   */
  className?: string;
  /**
   * 是否展示徽标红点
   * @default false
   */
  dot?: boolean;
  /**
   * 徽标内容
   */
  value?: string | number;
  /**
   * 徽标最大值
   * @default 99
   */
  maxValue?: number;
}

const formatValue = (value?: string | number, maxValue = 99): string | number => {
  if (value === '' || value === null || typeof value === 'undefined') return '';
  const numValue = +value;
  if (Number.isNaN(numValue)) {
    return value;
  }
  return numValue > maxValue ? `${maxValue}+` : numValue;
};

const Badge: FC<PropsWithChildren<IBadgeProps>> = ({ className = '', children, dot = false, value = '', maxValue = 99 }) => {
  const rootClassName = ['ink-badge'];
  const val = formatValue(value, maxValue);

  return (
    <View className={classNames(rootClassName, className)}>
      {children}
      {dot ? <View className="ink-badge__dot" /> : val !== '' && <View className="ink-badge__num">{val}</View>}
    </View>
  );
};

export default Badge;
